// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var cssVar = "--qs-tray-w";

var openKey = "gdc.guideOpen";

var stepKey = "gdc.guideExpandedStep";

var widthKey = "gdc.guideTrayWidth";

var emptyPayload = ({});

var userInteraction = {
  contents: false
};

function setUserInteraction() {
  userInteraction.contents = true;
}

function isTrayNarrowViewport(viewportWidth) {
  return viewportWidth < 1480;
}

function maxTrayWidth(viewportWidth) {
  return Math.round(viewportWidth * 0.55) | 0;
}

function clampTrayWidth(width, viewportWidth) {
  var maxW = maxTrayWidth(viewportWidth);
  return Math.max(260, Math.min(maxW, width));
}

function parseSavedTrayWidth(raw) {
  if (raw === undefined) {
    return 320;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n >= 260) {
    return n;
  } else {
    return 320;
  }
}

function getSavedTrayWidth() {
  try {
    return parseSavedTrayWidth(Caml_option.nullable_to_opt(localStorage.getItem(widthKey)));
  }
  catch (exn){
    return 320;
  }
}

function saveTrayWidth(width) {
  try {
    localStorage.setItem(widthKey, String(width));
    return ;
  }
  catch (exn){
    return ;
  }
}

function reservedPx(open_, trayW, viewportWidth) {
  if (!open_ || viewportWidth < 1480) {
    return 0;
  } else {
    return trayW;
  }
}

function isNearResizeEdge(clientX, panelLeft) {
  if (clientX >= panelLeft - 2.0) {
    return clientX <= panelLeft + 10;
  } else {
    return false;
  }
}

function applyTrayWidth(panel, width, viewportWidth) {
  var style = panel.style;
  if (viewportWidth < 1480) {
    style.width = "";
    style.maxWidth = "";
    return ;
  }
  var px = String(width) + "px";
  style.width = px;
  style.maxWidth = px;
}

function setCssVarReserved(open_, trayW, viewportWidth) {
  var px = String(reservedPx(open_, trayW, viewportWidth)) + "px";
  document.documentElement.style.setProperty(cssVar, px);
}

function applyVisualState(panel, open_, animate, viewportWidth) {
  if (animate) {
    panel.setAttribute("data-animate", "1");
    setTimeout((function () {
            panel.removeAttribute("data-animate");
          }), 220);
  }
  var style = panel.style;
  style.transform = open_ ? "translateX(0)" : "translateX(100%)";
  style.pointerEvents = open_ ? "" : "none";
  var trayW = getSavedTrayWidth();
  applyTrayWidth(panel, trayW, viewportWidth);
  setCssVarReserved(open_, trayW, viewportWidth);
}

function panelIsOpen(panel) {
  if (DomEl$GameDataCore.data(panel, "open") === "true") {
    return true;
  } else {
    return Caml_obj.equal(Caml_option.nullable_to_opt(localStorage.getItem(openKey)), "true");
  }
}

function mounted() {
  var self = this ;
  var panel = self.el;
  var wasOpen = Caml_obj.equal(Caml_option.nullable_to_opt(localStorage.getItem(openKey)), "true");
  var isOpenServerSide = DomEl$GameDataCore.data(panel, "open") === "true";
  var viewportWidth = window.innerWidth;
  applyVisualState(panel, isOpenServerSide, false, viewportWidth);
  var narrow = viewportWidth < 1480;
  self.pushEventTo(panel, "qs_panel_initialized", {
        open: narrow ? isOpenServerSide : wasOpen
      });
  if (!narrow && wasOpen && !isOpenServerSide) {
    self.pushEventTo(panel, "restore_open", emptyPayload);
  }
  var btn = document.getElementById("guide-close-btn");
  if (!(btn == null)) {
    DomEl$GameDataCore.on(btn, "click", (function (param) {
            userInteraction.contents = true;
          }));
  }
  var btn$1 = document.getElementById("assistant-btn");
  if (!(btn$1 == null)) {
    DomEl$GameDataCore.on(btn$1, "click", (function (param) {
            userInteraction.contents = true;
          }));
  }
  var btn$2 = document.getElementById("notifications-toggle-btn");
  if (!(btn$2 == null)) {
    DomEl$GameDataCore.on(btn$2, "click", (function (param) {
            userInteraction.contents = true;
          }));
  }
  var syncQsTrayVar = function (param) {
    var open_ = panelIsOpen(panel);
    var trayW = getSavedTrayWidth();
    applyTrayWidth(panel, trayW, window.innerWidth);
    setCssVarReserved(open_, trayW, window.innerWidth);
  };
  window.addEventListener("resize", syncQsTrayVar, {});
  self._qsResizeListener = syncQsTrayVar;
  var savedStep = localStorage.getItem(stepKey);
  if (!(savedStep == null)) {
    var serverStep = DomEl$GameDataCore.data(panel, "expanded-step");
    if (savedStep !== serverStep) {
      self.pushEventTo(panel, "restore_expanded_step", {
            step: savedStep
          });
    }
    
  }
  var onMouseMove = function ($$event) {
    var tmp = true;
    if (!self._qsIsResizing) {
      var viewportWidth = window.innerWidth;
      tmp = viewportWidth < 1480;
    }
    if (tmp) {
      return ;
    }
    if (!panelIsOpen(panel)) {
      return ;
    }
    var rect = panel.getBoundingClientRect();
    var nearEdge = isNearResizeEdge($$event.clientX, rect.left);
    panel.style.cursor = nearEdge ? "ew-resize" : "";
  };
  var onMouseDown = function ($$event) {
    var viewportWidth = window.innerWidth;
    if (viewportWidth < 1480 || !panelIsOpen(panel)) {
      return ;
    }
    var rect = panel.getBoundingClientRect();
    if (!isNearResizeEdge($$event.clientX, rect.left)) {
      return ;
    }
    self._qsIsResizing = true;
    var startX = $$event.clientX;
    var startWidth = panel.offsetWidth;
    var body = document.body;
    body.style.cursor = "ew-resize";
    body.style.userSelect = "none";
    $$event.preventDefault();
    DomEl$GameDataCore.addClass(document.documentElement, "qs-resizing");
    var onDocMouseMove = function (moveEvent) {
      if (!self._qsIsResizing) {
        return ;
      }
      var delta = startX - moveEvent.clientX;
      var newWidth = clampTrayWidth(startWidth + (delta | 0) | 0, window.innerWidth | 0);
      var px = String(newWidth) + "px";
      var style = panel.style;
      style.width = px;
      style.maxWidth = px;
      document.documentElement.style.setProperty(cssVar, px);
    };
    self._qsDocMouseMove = onDocMouseMove;
    var onDocMouseUp = function (param) {
      if (self._qsIsResizing) {
        self._qsIsResizing = false;
        body.style.cursor = "";
        body.style.userSelect = "";
        panel.style.cursor = "";
        saveTrayWidth(panel.offsetWidth);
        DomEl$GameDataCore.removeClass(document.documentElement, "qs-resizing");
        document.removeEventListener("mousemove", onDocMouseMove);
        document.removeEventListener("mouseup", onDocMouseUp);
        self._qsDocMouseMove = undefined;
        self._qsDocMouseUp = undefined;
        return ;
      }
      
    };
    self._qsDocMouseUp = onDocMouseUp;
    document.addEventListener("mousemove", onDocMouseMove);
    document.addEventListener("mouseup", onDocMouseUp);
  };
  self._qsMouseMove = onMouseMove;
  self._qsMouseDown = onMouseDown;
  DomEl$GameDataCore.on(panel, "mousemove", onMouseMove);
  DomEl$GameDataCore.on(panel, "mousedown", onMouseDown);
}

function updated() {
  var self = this ;
  var panel = self.el;
  if (self._qsIsResizing) {
    return ;
  }
  var isOpen = DomEl$GameDataCore.data(panel, "open") === "true";
  var localStorageOpen = Caml_obj.equal(Caml_option.nullable_to_opt(localStorage.getItem(openKey)), "true");
  var viewportWidth = window.innerWidth;
  var expandedStep = DomEl$GameDataCore.data(panel, "expanded-step");
  if (expandedStep !== "") {
    localStorage.setItem(stepKey, expandedStep);
  } else {
    localStorage.removeItem(stepKey);
  }
  if (isOpen) {
    userInteraction.contents = false;
    localStorage.setItem(openKey, "true");
    return applyVisualState(panel, true, false, viewportWidth);
  } else if (userInteraction.contents) {
    userInteraction.contents = false;
    localStorage.setItem(openKey, "false");
    return applyVisualState(panel, false, true, viewportWidth);
  } else if (localStorageOpen && viewportWidth >= 1480) {
    applyVisualState(panel, true, false, viewportWidth);
    self.pushEventTo(panel, "restore_open", emptyPayload);
    return ;
  } else {
    return applyVisualState(panel, false, false, viewportWidth);
  }
}

function destroyed() {
  var self = this ;
  var panel = self.el;
  self._qsIsResizing = false;
  var listener = self._qsResizeListener;
  if (listener !== undefined) {
    window.removeEventListener("resize", listener);
  }
  self._qsResizeListener = undefined;
  var handler = self._qsMouseMove;
  if (handler !== undefined) {
    panel.removeEventListener("mousemove", handler);
  }
  self._qsMouseMove = undefined;
  var handler$1 = self._qsMouseDown;
  if (handler$1 !== undefined) {
    panel.removeEventListener("mousedown", handler$1);
  }
  self._qsMouseDown = undefined;
  var handler$2 = self._qsDocMouseMove;
  if (handler$2 !== undefined) {
    document.removeEventListener("mousemove", handler$2);
  }
  self._qsDocMouseMove = undefined;
  var handler$3 = self._qsDocMouseUp;
  if (handler$3 !== undefined) {
    document.removeEventListener("mouseup", handler$3);
  }
  self._qsDocMouseUp = undefined;
}

function requestGuidePanelCloseForShowMe() {
  if (window.innerWidth >= 1480) {
    return new Promise((function (resolve) {
                  resolve();
                }));
  }
  var panel = document.getElementById("guide-tray");
  if (panel == null) {
    return new Promise((function (resolve) {
                  resolve();
                }));
  }
  if (DomEl$GameDataCore.data(panel, "open") !== "true") {
    return new Promise((function (resolve) {
                  resolve();
                }));
  }
  var closeBtn = document.getElementById("guide-close-btn");
  if (closeBtn == null) {
    return new Promise((function (resolve) {
                  resolve();
                }));
  } else {
    return new Promise((function (resolve) {
                  var settled = {
                    contents: false
                  };
                  var safetyTimer = {
                    contents: undefined
                  };
                  var onStop = {
                    contents: (function (param) {
                        
                      })
                  };
                  var finish = function () {
                    if (settled.contents) {
                      return ;
                    }
                    settled.contents = true;
                    var timer = safetyTimer.contents;
                    if (timer !== undefined) {
                      clearTimeout(Caml_option.valFromOption(timer));
                    }
                    window.removeEventListener("phx:page-loading-stop", onStop.contents);
                    resolve();
                  };
                  onStop.contents = (function (param) {
                      finish();
                    });
                  safetyTimer.contents = Caml_option.some(setTimeout((function () {
                              finish();
                            }), 550));
                  window.addEventListener("phx:page-loading-stop", onStop.contents, {
                        once: true
                      });
                  closeBtn.click();
                }));
  }
}

var guideTray = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var appShellMdMinPx = 1480;

var defaultTrayWidth = 320;

var minTrayWidth = 260;

var maxTrayWidthRatio = 0.55;

var resizeZonePx = 10;

var animMs = 200;

export {
  appShellMdMinPx ,
  defaultTrayWidth ,
  minTrayWidth ,
  maxTrayWidthRatio ,
  resizeZonePx ,
  cssVar ,
  openKey ,
  stepKey ,
  widthKey ,
  animMs ,
  emptyPayload ,
  userInteraction ,
  setUserInteraction ,
  isTrayNarrowViewport ,
  maxTrayWidth ,
  clampTrayWidth ,
  parseSavedTrayWidth ,
  getSavedTrayWidth ,
  saveTrayWidth ,
  reservedPx ,
  isNearResizeEdge ,
  applyTrayWidth ,
  setCssVarReserved ,
  applyVisualState ,
  panelIsOpen ,
  mounted ,
  updated ,
  destroyed ,
  requestGuidePanelCloseForShowMe ,
  guideTray ,
}
/* mounted Not a pure module */
